import { verifyPlanEffectiveDate } from './utilities';

describe('verifyPlanEffectiveDate', () => {
  let questions;
  beforeEach(() => {
    questions = {
      safeHarbor: {
        value: 'safeHarbor',
      },
      planEffectiveDate: {
        value: '2024-01-03',
      },
      hasTpa: {
        value: true,
      },
    };
  });
  test('fires callback when no tpa', () => {
    const callback = jest.fn();
    verifyPlanEffectiveDate({
      isSafeHarbor: questions.safeHarbor.value === 'safeHarbor',
      planDate: questions.planEffectiveDate.value,
      hasTpa: false,
      callback,
    });
    expect(callback).toHaveBeenCalled();
  });
  test('does not fire callback if tpa present', () => {
    const callback = jest.fn();
    verifyPlanEffectiveDate({
      isSafeHarbor: questions.safeHarbor.value === 'safeHarbor',
      planDate: questions.planEffectiveDate.value,
      hasTpa: questions.hasTpa.value,
      callback,
    });
    expect(callback).not.toHaveBeenCalled();
  });
  test('does not fire callback if planDate is 21 days out', () => {
    const targetDate = new Date();
    targetDate.setDate(targetDate.getDate() + 25);
    const dateString = targetDate.toISOString().split('T')[0];
    const callback = jest.fn();
    verifyPlanEffectiveDate({
      isSafeHarbor: questions.safeHarbor.value === 'safeHarbor',
      planDate: dateString,
      hasTpa: false,
      callback,
    });
    expect(callback).not.toHaveBeenCalled();
  });
});
